import TextareaInitializer from 'textarea-initializer'

// 日報フォームの「課題の追加」で挿入した作業リストの入力欄にも、マークダウンの入力補助（プレビュー・ファイル挿入など）を適用する。
// 最初から表示している入力欄は textarea.js が .js-markdown でまとめて初期化している。
// 同じセレクタで初期化し直すと既存の入力欄に二重に登録されるため、挿入した入力欄だけを id で指定する
const GOAL_SELECTOR = '.js-daily-report-schedule-goal'

$(document).on('cocoon:after-insert', (_event, insertedItem) => {
  $(insertedItem)
    .find(GOAL_SELECTOR)
    .each((_index, textarea) => {
      TextareaInitializer.initialize(`#${textarea.id}`)
    })
})
